import httpClient from './httpClient'
import axios from 'axios'

export default {
  async generateSignedUrl(imageObject) {
    const ret = await httpClient.post('/images?type=upload', imageObject)
    return ret
  },
  async saveImageOnS3(uploadUrl, blob) {
    const ret = await axios.put(`${uploadUrl}`, blob, {
      headers: { 'content-type': blob.type },
    })
    return ret
  },
  async saveImageOnDB(id, imageObject) {
    const ret = await httpClient.post(`/images/${id}`, imageObject)
    return ret
  },
  async deleteImage(id) {
    const ret = await httpClient.delete(`/images/${id}`)
    return ret
  },
  async handleUploadImage(blob, imageObject) {
    const { data: s3SignedData } = await this.generateSignedUrl(imageObject)
    await this.saveImageOnS3(s3SignedData[0].uploadUrl, blob)
    const { data: dbData } = await this.saveImageOnDB(s3SignedData[0].id, {
      ...imageObject[0],
      ...{ metadata: {} },
    })
    return dbData
  },
}
